import RequestAjax from './httpRequest';
import downloadConfig from './downloadConfig'; //下载配置模块
import { PeerConnection, nativeRTCIceCandidate, nativeRTCSessionDescription } from './adapter';

// 块大小
let { BLOCK_SIZE } = downloadConfig;
// P2P接收数据块大小
let { P2PBLOCK_SIZE } = downloadConfig;
//接收数据的超时设置
let { receiveDataTimeOut } = downloadConfig;

/*******************P2P模块*********************/
let moz = !!navigator.mozGetUserMedia;
let iceServer = {
    iceServers: [
        {
            url: 'stun:111.202.92.70:3578',
            urls: 'stun:111.202.92.70:3578',
        },
    ],
};

// 保存已经通过连接的种子
let gGoodPeerIds = [];
// 保存已经尝试过打不通的种子
let gBadPeerIds = [];

// 查找已存在的种子
function selectPeer(peerArray, peerIds) {
    let peerIndexs = [];
    for (let i = 0; i < peerArray.length; i++) {
        for (let j = 0; j < peerIds.length; j++) {
            if (peerArray[i] == peerIds[j]) {
                peerIndexs.push(i);
            }
        }
    }
    return peerIndexs;
}

// 请求类型
let P2PHttpRequestType = {
    REQUEST_NULL: 0,
    GET_PEER: 1,
    SEND_CANDIDATE_OFFER: 2,
};
// 连接信息
function PeerConnectInfo() {
    // candidate
    this.candidate = [];
    this.session_desc = null;
}

//获取到candidate
function gotLocalCandidate(that) {
    return function(evt) {
        if (evt.candidate) {
            that.mPeerConnectInfo.candidate.push(evt.candidate.candidate);
            console.log('pc.onicecandidate', that.mTimer);
        }
    };
}

function gotReceiveChannel(that) {
    return function(evt) {
        console.log('receiveChannel');
        that.receiveChannel = evt.channel;
        that.addDataChannel(peerId, that.receiveChannel);
    };
}

function channelOpen(that) {
    return function() {
        console.log('channel.onopen mTimer');
        window.clearTimeout(that.mTimer);
        that.mTimer = null;
        gGoodPeerIds.push(that.mCurrentPeerId);
        that.receiveDataTimer = setTimeout(that.checkDataLength(that), receiveDataTimeOut);
    };
}

function channelClose(that) {
    return function(event) {
        console.log('sendchannelClose');
        window.clearTimeout(that.mTimer);
        that.mTimer = null;
        if (that.dataChannel != null && that.dataChannel != undefined) {
            delete that.dataChannel;
            that.dataChannel = null;
        }
        //换种子
        //that.changePeer();
    };
}

function receiveChannelClose(that) {
    return function(event) {
        console.log('receivechannelClose');
        window.clearTimeout(that.mTimer);
        that.mTimer = null;
        if (that.dataChannel != null && that.dataChannel != undefined) {
            delete that.dataChannel;
            that.dataChannel = null;
        }
        //换种子
        //that.changePeer();
    };
}

function channelOnmessage(that) {
    return function(message) {
        console.log('recv message');
        if (that.receiveTime == 0) {
            that.receiveTime = new Date().getTime();
        }
        let arrayBuf = new Uint8Array(message.data);
        //console.log("recv message:" + message.data);
        let headInfo = new Uint32Array(message.data);
        let recvData = that.analysisData(arrayBuf, headInfo);

        if (recvData != null && recvData != undefined) {
            that.putData(recvData);
        }
    };
}

function channelError(that) {
    return function(err) {
        console.log('channelError');
        window.clearTimeout(that.mTimer);
        that.mTimer = null;
        if (that.dataChannel != null && that.dataChannel != undefined) {
            delete that.dataChannel;
            that.dataChannel = null;
        }
        //换种子
        that.changePeer();
        console.log('channel.onmessage data_channel_error ' + err);
    };
}

/*******************P2P下载数据类*********************/
function P2PDownload() {
    // url
    this.mURL = '';
    // 服务器返回的种子
    this.mPeerIds = [];
    // 块号
    this.mBlockInfo = null;
    // 当前请求种子Id
    this.mCurrentPeerId = 0;
    //保存所有与本地相连的peer connection， 键为socket id，值为PeerConnection类型
    this.peerConnection = null;
    //保存所有的data channel，键为socket id，值通过PeerConnection实例的createChannel创建
    this.dataChannel = null;
    // 连接信息
    this.mPeerConnectInfo = null;
    // 接收数据
    this.mData = new Uint8Array(BLOCK_SIZE);
    // 接收数据表
    this.mDataRecvTable = [];
    // 服务器信息
    this.mServerInfo = null;
    // 当前状态
    this.mStatus = P2PHttpRequestType.REQUEST_NULL;
    // 下载模块对象
    this.mDownloadModel = null;
    // 定时器
    this.mTimer = null;
    //http请求
    this.httpRequest = new RequestAjax();
    this.HttpRequestResponse = this.httpRequest.HttpRequestResponse;
    this.receiveDataTimer = null;
    this.repeatGetPeer = 0;
    //测试看p2p下载完成一块所用时间
    this.receiveTime = 0;
    this.endReceiveTime = 0;
    //信道打开重试次数
    this.channelRepeatNum = 0;
    // 是否是首次请求调度地址
    this.isFirstReqTrack = true;
}
//检查下载的数据长度
P2PDownload.prototype.checkDataLength = function(that) {
    return function() {
        let recvCount = 0;
        for (let i = 0; i < that.mDataRecvTable.length; i++) {
            if (that.mDataRecvTable[i] == 0) {
                break;
            }
            recvCount++;
        }
        if (recvCount < that.mDataRecvTable.length) {
            //长时间没有收到数据，中断本次传输
            if (that.endReceiveTime == 0) {
                that.endReceiveTime = new Date().getTime();
                that.mDownloadModel.p2pRate = recvCount * 1000 / (parseInt(that.endReceiveTime) - parseInt(that.receiveTime));
                console.error(
                    '超时下载速率字节每毫秒(kB/s):',
                    recvCount * 1000 / (parseInt(that.endReceiveTime) - parseInt(that.receiveTime)),
                );
                that.receiveTime = 0;
            }
            //长时间没有收到数据
            that.changePeer();
        }
    };
};

// 设置下载数据
P2PDownload.prototype.setDownloadInfo = function(downloadModel, nIndex) {
    this.mDownloadModel = downloadModel;
    this.mURL = downloadModel.seedUrl;
    this.mBlockId = downloadModel.mDataBlockArray[nIndex].mBlockId;
    this.mServerInfo = downloadModel.mServerInfo;
    this.showTestInfo = downloadModel.showTestInfo;
    this.p2pErrorNum = downloadModel.p2pErrorNum;
    this.mBlockInfo = {};
    this.mBlockInfo.mBlockId = downloadModel.mDataBlockArray[nIndex].mBlockId;
    this.mBlockInfo.mStartPos = downloadModel.mDataBlockArray[nIndex].mStartPos;
    this.mBlockInfo.mEndPos = downloadModel.mDataBlockArray[nIndex].mEndPos;
    this.requestStartPos = this.mBlockInfo.mStartPos;
    let len = this.mBlockInfo.mEndPos - this.mBlockInfo.mStartPos + 1;
    this.mDataRecvTable = new Uint8Array(parseInt(len / P2PBLOCK_SIZE) + (len % P2PBLOCK_SIZE > 0 ? 1 : 0));
    if(this.showTestInfo){
        console.info('新建p2p下载：' + nIndex);
    }
    this.sendRequestPeer();
};

// 取消下载
P2PDownload.prototype.cancleDownload = function() {
    this.mStatus = P2PHttpRequestType.REQUEST_NULL;
    if(this.showTestInfo){
        console.info('取消下载：' + this.mBlockId);
    }
    window.clearTimeout(this.mTimer);
    this.mTimer = null;
    this.httpRequest.stop();

    if (this.dataChannel != null && this.dataChannel != undefined) {
        this.dataChannel.removeEventListener('open', channelOpen(this));

        this.dataChannel.removeEventListener('close', channelClose(this));
        this.dataChannel.removeEventListener('message', channelOnmessage(this));

        this.dataChannel.removeEventListener('error', channelError(this));
        //this.dataChannel.close();

        this.dataChannel = null;
    }

    if (this.receiveChannel != null && this.receiveChannel != undefined) {
        this.receiveChannel.removeEventListener('open', channelOpen(this));

        this.receiveChannel.removeEventListener('close', receiveChannel(this));

        this.receiveChannel.removeEventListener('message', channelOnmessage(this));

        this.receiveChannel.removeEventListener('error', channelError(this));
        //this.receiveChannel.close();
        this.receiveChannel = null;
    }

    if (this.peerConnection != null && this.peerConnection != undefined) {
        this.peerConnection.removeEventListener('icecandidate', gotLocalCandidate(this));
        this.peerConnection.removeEventListener('datachannel', gotReceiveChannel(this));
        //this.peerConnection.close();
        this.peerConnection = null;
    }
};
// 获取已下载数据
P2PDownload.prototype.getData = function() {
    let buf = null;
    let nIndex = this.mDataRecvTable.length;
    for (let i = 0; i < this.mDataRecvTable.length; i++) {
        if (this.mDataRecvTable[i] == 0) {
            nIndex = i;
            break;
        }
    }

    if (nIndex != 0) {
        buf = new Uint8Array(nIndex * P2PBLOCK_SIZE);
        buf.set(this.mData.slice(0, nIndex * P2PBLOCK_SIZE), 0);
    }
    return buf;
};

// 发送请求种子
P2PDownload.prototype.sendRequestPeer = function() {
    if (this.mServerInfo == null || this.mServerInfo == undefined || this.mServerInfo.length <= 0) {
        return;
    }
    let postURL = this.mServerInfo;
    if (postURL.sub(postURL.length - 1, 1) != '/') {
        postURL += '/';
    }

    postURL += 'queryRes?resId=';
    postURL += this.mURL; //todo上线的时候需要编码
    postURL += '&blockNum=';
    postURL += this.mBlockInfo.mBlockId;
    //postURL += "&temp";
    this.mStatus = P2PHttpRequestType.GET_PEER;
    // 像服务器发送http请求 请求种子
    if(this.showTestInfo){
        console.info('请求种子信息');
    }

    if(this.p2pErrorNum < 10){
        this.httpRequest.sendRequest('get', 'json', postURL, 2000).then(data => {
            this.httpRequestCallback(...data);
        });
    }

    //console.log("P2P blockId:" + this.mBlockInfo.mBlockId + " getPeer:" + postURL);
};

// 创建连接
P2PDownload.prototype.createPeerConnectionFromPeerId = function(peerId) {
    // 设置连接超时
    this.peerConnection = this.createPeerConnection(peerId); //webrtc点对点连接
    this.dataChannel = this.createDataChannel(peerId);
    this.createOffer();
};

// 发送candidate和offer
P2PDownload.prototype.sendCandidateAndOffer = function() {
    if (this.mServerInfo == null || this.mServerInfo == undefined || this.mServerInfo.length <= 0) {
        return;
    }
    let postURL = this.mServerInfo;
    if (postURL.sub(postURL.length - 1, 1) != '/') {
        postURL += '/';
    }

    postURL += 'sendTo?peerId=';
    postURL += this.mCurrentPeerId;
    postURL += '&data=';

    let recvCount = 0;
    for (let i = 0; i < this.mDataRecvTable.length; i++) {
        if (this.mDataRecvTable[i] == 0) {
            break;
        }
        recvCount++;
    }
    if(this.showTestInfo){
        console.log('请求偏移位置', this.mBlockInfo.mStartPos + recvCount * 1024);
    }
    this.requestStartPos = this.mBlockInfo.mStartPos + recvCount * 1024;

    let datajson = {
        requestURL: this.mURL,
        videoType: 0,
        offset: this.requestStartPos,
        blockNum: this.mBlockInfo.mBlockId,
        candidate: this.mPeerConnectInfo.candidate,
        offer: this.mPeerConnectInfo.session_desc,
        peerId: this.mCurrentPeerId,
    };
    let strjson = {
        action: 'applyConnectRequest',
        data: datajson,
    };
    postURL += JSON.stringify(strjson);

    this.mStatus = P2PHttpRequestType.SEND_CANDIDATE_OFFER;
    // 发送candidte，请求offer
    if(this.p2pErrorNum < 10){
        this.httpRequest.sendRequest('get', 'json', postURL, 20000).then(data => {
            this.httpRequestCallback(...data);
        });
    }
    if(this.showTestInfo){
        console.info('sendCandidateAndOffer');
        console.log('P2P blockId:' + this.mBlockInfo.mBlockId + ' sendCandidateAndOffer:' + postURL);
    }
};

// 创建连接
P2PDownload.prototype.createPeerConnection = function(peerId) {
    let that = this;
    let pc;
    if(this.showTestInfo){
        console.log('createPeerConnection peerId:' + peerId);
    }
    // if (this.mPeerConnectInfo != null || this.mPeerConnectInfo != undefined) {
    //     this.mPeerConnectInfo = null;
    // }

    this.mPeerConnectInfo = {
        candidate: [],
        session_desc: null,
    };
    try {
        pc = new PeerConnection(iceServer);
    } catch (error) {
        console.log('创建peerconnection失败，关闭p2p');
        this.downloadModel.stopP2P(this.mBlockId);
    }

    if (this.mTimer == null || this.mTimer == undefined) {
        this.mTimer = setTimeout(p2pTimerCallback(this, 'ON_CANDIDATE_RECV'), 1000);
        if(this.showTestInfo){
            console.log('设置接收candidate超时的定时器', this.mTimer);
        }
    }
    pc.addEventListener('icecandidate', gotLocalCandidate(that));
    pc.addEventListener('datachannel', gotReceiveChannel(that));
    return pc;
};

//对某一个PeerConnection创建Data channel
P2PDownload.prototype.createDataChannel = function(peerId, label) {
    console.log('skyrtc.prototype.createDataChannel');
    let pc, key, channel;
    pc = this.peerConnection;

    if (!(pc instanceof PeerConnection)) {
        console.log('skyrtc.prototype.createDataChannel data_channel_create_error');
    }
    try {
        channel = pc.createDataChannel(label, {
            maxRetransmits: 3,
        });
    } catch (error) {
        console.log('skyrtc.prototype.createDataChannel channel_create_error');
    }
    return this.addDataChannel(peerId, channel);
};

//为Data channel绑定相应的事件回调函数
P2PDownload.prototype.addDataChannel = function(peerId, channel, receive) {
    console.log('skyrtc.prototype.addDataChannel');
    let that = this;
    if(channel){
        channel.addEventListener('open', channelOpen(that));
        if (receive) {
            channel.addEventListener('close', receiveChannel(that));
        } else {
            channel.addEventListener('close', channelClose(that));
        }

        channel.addEventListener('message', channelOnmessage(that));

        channel.addEventListener('error', channelError(that));
    }
    return channel;
};

// 将接收到的数据放入数据区
P2PDownload.prototype.putData = function(recvData) {
    this.mData.set(recvData.mData, recvData.mStartPos);
    let nIndex = parseInt(recvData.mStartPos / P2PBLOCK_SIZE);
    this.mDataRecvTable[nIndex] = 1;
    let recvCount = 0;
    for (let i = 0; i < this.mDataRecvTable.length; i++) {
        if (this.mDataRecvTable[i] == 0) {
            break;
        }
        recvCount++;
    }

    if (recvCount >= this.mDataRecvTable.length) {
        // 接收完成
        if (this.mDownloadModel != null || this.mDownloadModel != undefined) {
            console.log('p2p下载完成' + this.mBlockInfo.mBlockId);
            this.endReceiveTime = new Date().getTime();

            //let alreadyDown = this.requestStartPos - this.mBlockInfo.mStartPos;
            //console.error(this.endReceiveTime,'kb数',(this.mBlockInfo.mEndPos - this.requestStartPos)/1024)
            this.mDownloadModel.p2pRate = (this.mBlockInfo.mEndPos - this.requestStartPos) / 1024 * 1000 / (parseInt(this.endReceiveTime) - parseInt(this.receiveTime));
            if(this.showTestInfo){
                console.info(
                    '下载数据速度kb/s：',
                    (this.mBlockInfo.mEndPos - this.requestStartPos) /
                        1024 *
                        1000 /
                        (parseInt(this.endReceiveTime) - parseInt(this.receiveTime)),
                );
            }
            //停止数据长度检查
            window.clearTimeout(this.receiveDataTimer);
            this.receiveDataTimer = null;
            this.mDownloadModel.p2pRecvFinishCallback(this.mBlockId);
        }
    }
};
// 接收数据信息
// function recvDataInfo() {
//     // 数据类型
//     this.mDataType = 0;
//     // 数据长度
//     this.mDataBufferLength = 0;
//     // 实际传输数据长度
//     this.mDataLength = 0;
//     this.mSequcenceNumber = 0;
//     this.mSendOrder = 0;
//     this.mStartPos = 0;
//     this.mEndPos = 0;
//     this.mBlockId = 0;
//     this.mData = null;
// }

//解析数据
P2PDownload.prototype.analysisData = function(data, headInfo) {
    let recvData = null;
    recvData = {};
    recvData.mDataType = headInfo[0];
    recvData.mBlockId = headInfo[8];
    // 数据长度
    recvData.mDataBufferLength = headInfo[1];
    // 实际传输数据长度
    recvData.mDataLength = headInfo[2];
    if (this.mBlockInfo.mStartPos == this.requestStartPos) {
        recvData.mStartPos = headInfo[6];
    } else {
        recvData.mStartPos = headInfo[6] + this.requestStartPos - this.mBlockInfo.mStartPos;
    }
    recvData.mEndPos = headInfo[7];
    recvData.mData = new Uint8Array(recvData.mDataLength);
    recvData.mData.set(data.slice(36, recvData.mDataBufferLength), 0);
    return recvData;
};

/***********************信令交换部分*******************************/

//向所有PeerConnection发送Offer类型信令
P2PDownload.prototype.createOffer = function() {
    let i,
        m,
        pc,
        that = this,
        pcCreateOfferCbGen = function(pc, peerId) {
            return function(session_desc) {
                console.log('pcCreateOfferCbGen');
                pc.setLocalDescription(session_desc);
                that.mPeerConnectInfo.session_desc = session_desc;
            };
        },
        pcCreateOfferErrorCb = function(error) {
            console.log(error);
        };
    if (this.peerConnection) {
        this.peerConnection.createOffer(
            pcCreateOfferCbGen(this.peerConnection, this.mCurrentPeerId),
            pcCreateOfferErrorCb,
        );
        console.log('createOffers');
    }
};

//接收到answer类型信令后将对方的session描述写入PeerConnection中
P2PDownload.prototype.receiveAnswer = function(peerId, sdp) {
    console.log('receiveAnswer');
    if (peerId == this.mCurrentPeerId && this.peerConnection) {
        this.peerConnection.setRemoteDescription(new nativeRTCSessionDescription(sdp));
    }
};

// 定时器回调函数
function p2pTimerCallback(p2pDownloadObj, type) {
    console.log('定时器开启', type);
    return function() {
        console.info('启动定时器' + type);
        if (type == 'GET_PEER_TIMEOUT') {
            if (p2pDownloadObj.repeatGetPeer < 3) {
                p2pDownloadObj.sendRequestPeer();
                if (p2pDownloadObj.repeatGetPeer == 1) {
                    gBadPeerIds = [];
                }
            } else {
                p2pDownloadObj.mDownloadModel.p2pCreateNew(p2pDownloadObj.mBlockInfo.mBlockId);
            }
            p2pDownloadObj.repeatGetPeer++;
        } else if (type == 'ON_CANDIDATE_RECV') {
            if (p2pDownloadObj.mPeerConnectInfo.candidate.length > 0) {
                // 发送httprequest请求，发送本地candidate信息
                console.info('webrtc点对点连接收到candidate');
                p2pDownloadObj.sendCandidateAndOffer();
            } else {
                p2pDownloadObj.mTimer = setTimeout(p2pTimerCallback(p2pDownloadObj, 'ON_CANDIDATE_TIMEOUT'), 5000);
            }
        } else if (type == 'ON_CANDIDATE_TIMEOUT') {
            // 创建连接
            console.info('ON_CANDIDATE_TIMEOUT');
            if (p2pDownloadObj.mPeerConnectInfo.candidate.length > 0) {
                console.info('重新检测webrtc点对点连接收到candidate');
                p2pDownloadObj.sendCandidateAndOffer();
            } else {
                p2pDownloadObj.createPeerConnectionFromPeerId(p2pDownloadObj.mCurrentPeerId);
            }
        } else if (type == 'GET_PEER_EMPTY') {
            if (p2pDownloadObj.mDownloadModel != null && p2pDownloadObj.mDownloadModel != undefined) {
                p2pDownloadObj.mDownloadModel.p2pCreateNew(p2pDownloadObj.mBlockInfo.mBlockId);
            }
        } else if (type == 'DATA_CHANNEL_OPEN_TIMEOUT') {
            this.channelRepeatNum++;
            gBadPeerIds.push(p2pDownloadObj.mCurrentPeerId);
            // 换种子
            p2pDownloadObj.changePeer();
        }
        p2pDownloadObj.mTimer = null;
    };
}

// 获取数据
P2PDownload.prototype.httpRequestCallback = function(result, requestType, xmlhttp, startPos, endPos, errorCode) {
    if (result == this.HttpRequestResponse.RESPONSE_RETURN_SUCCESS) {
        //let jsonStr = JSON.stringify(xmlhttp.response);
        let jsonStr = xmlhttp.response;
        // 请求种子返回
        if (this.mStatus == P2PHttpRequestType.GET_PEER) {
            let requestStatus = jsonStr.status;

            console.log('P2P blockId:' + this.mBlockInfo.mBlockId + ' getPeerReturn:' + JSON.stringify(jsonStr));
            if (requestStatus != null && requestStatus != undefined && requestStatus != '0') {
                let strPeers = jsonStr.data;
                let peerIds = strPeers.split(',');
                // 查找是否有已经打通过的种子
                let badPeerIndex = selectPeer(peerIds, gBadPeerIds);
                if (badPeerIndex != null && badPeerIndex != undefined && badPeerIndex.length > 0) {
                    for (let i = 0; i < badPeerIndex.length; i++) {
                        peerIds.splice(badPeerIndex[i], 1);
                    }
                }

                this.mPeerIds = peerIds;
                console.log('请求种子个数为:' + this.mPeerIds.length);
                if (this.createConnect() == false) {
                    // 像服务器发送http请求 请求种子， 过一会再查询
                    if (this.mTimer == null || this.mTimer == undefined) {
                        this.mTimer = setTimeout(p2pTimerCallback(this, 'GET_PEER_TIMEOUT'), 5000);
                    }
                }
            } else {
                //请求种子返回错误状态
                if (this.mTimer == null || this.mTimer == undefined) {
                    this.mTimer = setTimeout(p2pTimerCallback(this, 'GET_PEER_EMPTY'), 2000);
                }
            }
        } else if (this.mStatus == P2PHttpRequestType.SEND_CANDIDATE_OFFER) {
            //收到_ice_candidate
            console.log('P2P blockId:' + this.mBlockInfo.mBlockId + ' recvAnswer:' + JSON.stringify(jsonStr));
            if (jsonStr.action == 'applyConnectResponse') {
                let requestStatus = jsonStr.status;
                if (requestStatus == '1') {
                    let jsonData = jsonStr.data;
                    if (jsonData != null && jsonData != undefined) {
                        console.log('applyConnectResponse:' + JSON.stringify(jsonStr));

                        let candidatejson = jsonData.candidate;
                        if (jsonData.peerId == this.mCurrentPeerId) {
                            this.receiveAnswer(jsonData.peerId, jsonData.answer);
                            for (let i = 0; i < candidatejson.length; i++) {
                                let jsonCandidate = {
                                    candidate: candidatejson[i],
                                };
                                let candidate = new nativeRTCIceCandidate(jsonCandidate);
                                if (this.peerConnection) {
                                    this.peerConnection.addIceCandidate(candidate);
                                }
                            }
                        }
                        //设置定时器等待datachannel联通
                        if (this.mTimer == null || this.mTimer == undefined) {
                            this.mTimer = setTimeout(p2pTimerCallback(this, 'DATA_CHANNEL_OPEN_TIMEOUT'), 5000);
                        }
                    }
                } else {
                    //请求失败换种子请求,若种子数组长度为0，重新请求种子
                    this.changePeer();
                }
            }else{
                // 收到candidte出错
                this.mDownloadModel.p2pCreateNew(this.mBlockInfo.mBlockId);
            }
        }
    } else if (result == this.HttpRequestResponse.RESPONSE_RETURN_ERROR) {
        // 请求失败
        console.info(
            '请求失败,errorCode:' + errorCode + 'status:' + this.mStatus,
            this.mBlockInfo.mBlockId,
            this.mBlockId,
        );
        this.p2pErrorNum += 1;
        this.mDownloadModel.p2pErrorNum = this.p2pErrorNum;
        this.mTimer = setTimeout(p2pTimerCallback(this, 'GET_PEER_EMPTY'), 2000);
    } else if (result == this.HttpRequestResponse.RESPONSE_TIMEOUT) {
        // 请求超时
        let strOutInfo = '';
        strOutInfo = '请求超时,请求类型：' + requestType;
        if (this.mStatus == P2PHttpRequestType.GET_PEER) {
            // 过一会再查询
            if (this.mTimer == null || this.mTimer == undefined) {
                this.mTimer = setTimeout(p2pTimerCallback(this, 'GET_PEER_TIMEOUT'), 5000);
            }
        } else if (this.mStatus == P2PHttpRequestType.SEND_CANDIDATE_OFFER) {
            //收到_ice_candidate
            // 换种子
            this.changePeer();
        }
        console.log(strOutInfo);
    }
};

// 换种子
P2PDownload.prototype.changePeer = function() {
    this.receiveTime = 0;
    console.log('changePeer');
    this.cancleDownload();
    // 删除当前种子
    this.deleteCurrentPeer();
    console.log('换种子之后的长度', this.mPeerIds.length);
    this.mTimer = null;
    if (this.createConnect() == false) {
        // 像服务器发送http请求 请求种子， .
        if (this.mTimer == null || this.mTimer == undefined) {
            this.mTimer = setTimeout(p2pTimerCallback(this, 'GET_PEER_TIMEOUT'), 5000);
            console.log('changePeer启动定时器，重新请求', this.mTimer);
        }
    }
};

//删除当前种子
P2PDownload.prototype.deleteCurrentPeer = function() {
    for (let i = 0; i < this.mPeerIds.length; i++) {
        if (this.mPeerIds[i] == this.mCurrentPeerId) {
            this.mPeerIds.splice(i, 1);
        }
    }
};
// 获取数据
P2PDownload.prototype.createConnect = function() {
    let bSuccess = false;
    if (this.mPeerIds.length > 0) {
        let goodPeerIndex = selectPeer(this.mPeerIds, gGoodPeerIds);
        let peerIndex = 0;
        if (goodPeerIndex != null && goodPeerIndex != undefined && goodPeerIndex.length > 0) {
            // 取出一个种子连接
            peerIndex = goodPeerIndex[0];
        }
        this.mCurrentPeerId = this.mPeerIds[peerIndex];
        // 创建连接
        console.log('创建webtrc连接');
        this.createPeerConnectionFromPeerId(this.mCurrentPeerId);
        bSuccess = true;
    }
    return bSuccess;
};

export default P2PDownload;



// WEBPACK FOOTER //
// ./components/f.component.mediasource/app/modules/p2p.js